import { useEffect, useRef } from "react";

/** Reset both the document and desktop results pane, but not an initial deep link. */
export function useSearchPaginationScroll(currentPage: number) {
  const resultsPaneRef = useRef<HTMLDivElement>(null);
  const previousPage = useRef(currentPage);

  useEffect(() => {
    if (previousPage.current === currentPage) return;
    previousPage.current = currentPage;
    // Explicit instant behaviour also overrides global CSS smooth scrolling.
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    resultsPaneRef.current?.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [currentPage]);

  return resultsPaneRef;
}
